<template>
  <div class="hezuo-wapper-container">
    <h1 class="title">{{$t('home.partnership.h1')}}</h1>
    <div class="sub-title">{{ $t('home.partnership.pin-yin') }}</div>
    <div class="logo-container">
      <div class="logo-item" v-for="(item,index) in imgs" :key="index">
        <img :src="item.url" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            imgs:[
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_01.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_02.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_03.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_04.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_05.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_06.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_07.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_08.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_09.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_10.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_11.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_12.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_13.png')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_14.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_15.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_16.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_17.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_18.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_19.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_20.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_21.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_22.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_23.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_24.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_25.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_26.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_27.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_28.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_29.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_30.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_31.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_32.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_33.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_34.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_35.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_36.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_37.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_38.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_39.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_40.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_41.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_42.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_43.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_44.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_45.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_46.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_47.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_48.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_49.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_50.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_51.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_52.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_53.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_54.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_55.jpg')},
              {title:'',url:require('../../../assets/images/home/he-zuo/hzhb_56.jpg')},
            ]
        }
    },
}
</script>

<style lang="less" scoped>
.hezuo-wapper-container{
  padding-top: 24px;
  .title{
    width: 100%;
    text-align: center;
    margin: 0;
    color: #ff5d1b;
  }
  .sub-title{
    width: 100%;
    text-align: center;
  }
  .logo-container{
    box-sizing: border-box;
    padding: 48px 120px 48px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
    .logo-item{
      margin: 12px 24px;
      width: 155px;
      height: 44px;
      img{
        width: 100%;
        height: 100%;
        cursor: pointer;
        transition-property:box-shadow;
        transition-duration:0.3s;
        &:hover{
          border-radius: 6px;
          box-shadow: 0 0 8px rgba(248, 142, 2, 0.6);
        }
      }
    }
  }
}
</style>